import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

// Define a service using a base URL and expected endpoints
export const chargesApi = createApi({
  reducerPath: 'charges',
  tagTypes: ['Charge'],
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getCharge: builder.query({
      query: ({ id, ...params }) => ({
        method: 'GET',
        endpoint: `/charges/${id}`,
        body: params,
      }),
      providesTags: ['Charge'],
    }),
    getListCharges: builder.query({
      query: (params = {}) => ({
        method: 'GET',
        endpoint: `/charges`,
        body: params,
      }),
      providesTags: ['Charge'],
    }),
    getListPreviousCharges: builder.query({
      query: (params = {}) => ({
        method: 'GET',
        endpoint: `/charges/previous`,
        body: params,
      }),
      providesTags: ['Charge'],
    }),
    processCharge: builder.mutation({
      query: ({ id, query, ...params }) => ({
        method: 'POST',
        endpoint: `/charges/${id}/process`,
        body: params,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetChargeQuery,
  useLazyGetChargeQuery,
  useGetListChargesQuery,
  useGetListPreviousChargesQuery,
  useProcessChargeMutation,
} = chargesApi;
